var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReservationListEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 113,
    viewBox: "0 0 250 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2036_2106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.99 45.4805H218.435V71.6323H225.99V45.4805Z",
    fill: "#CCD6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.979 66.7126L212.604 44.8527L175.72 45.1898L153.346 66.9829L153.798 67.2735H153.636V112.603H230.93V67.2735L230.979 66.7126Z",
    fill: "#CCD6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.623 44.8993L189.668 71.8121V112.603H230.93V66.6924L212.623 44.8993Z",
    fill: "#E5EBED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.657 90.0453H206.23V97.4935H214.657V90.0453Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.657 77.1532H206.23V84.4833H214.657V77.1532Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.657 90.0453H206.23V97.4935H214.657V90.0453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.657 77.1532H206.23V84.4833H214.657V77.1532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.208 88.069H168.781V95.5172H177.208V88.069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.208 75.1769H168.781V82.507H177.208V75.1769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.37 45.4805H158.815V71.6323H166.37V45.4805Z",
    fill: "#CCD6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.36 66.7126L152.985 44.8527L116.101 45.1898L93.7266 66.9829L94.1787 67.2735H94.0171V112.603H171.31V67.2735L171.36 66.7126Z",
    fill: "#CCD6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.004 44.8993L130.049 71.8121V112.603H171.311V66.6924L153.004 44.8993Z",
    fill: "#E5EBED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.038 90.0453H146.611V97.4935H155.038V90.0453Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.038 77.1532H146.611V84.4833H155.038V77.1532Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.038 90.0453H146.611V97.4935H155.038V90.0453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.038 77.1532H146.611V84.4833H155.038V77.1532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.589 88.069H109.162V95.5172H117.589V88.069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.589 75.1769H109.162V82.507H117.589V75.1769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.324 22.9109H95.2285V57.8561H105.324V22.9109Z",
    fill: "#CCD6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.991 51.2821L87.4373 22.0721L38.1515 22.5225L8.25391 51.6435L8.85786 52.0318H8.64218V112.603H111.925V52.0318L111.991 51.2821Z",
    fill: "#CCD6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4632 22.1343L56.7891 58.0965V112.603H111.925V51.2553L87.4632 22.1343Z",
    fill: "#E5EBED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.181 82.4603H78.9209V92.413H90.181V82.4603Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.181 65.2334H78.9209V75.0282H90.181V65.2334Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.181 82.4603H78.9209V92.413H90.181V82.4603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.181 65.2334H78.9209V75.0282H90.181V65.2334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.14 79.8195H28.8799V89.7721H40.14V79.8195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.14 62.5925H28.8799V72.3873H40.14V62.5925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.471 112.38H0V112.881H241.471V112.38Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0443 103.168C42.0701 103.168 45.3337 96.5089 45.3337 88.2946C45.3337 80.0803 42.0701 73.4213 38.0443 73.4213C34.0185 73.4213 30.7549 80.0803 30.7549 88.2946C30.7549 96.5089 34.0185 103.168 38.0443 103.168Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7172 112.64C35.7977 95.1235 38.6878 77.6704 38.7173 77.4963L39.2852 77.5925C39.2558 77.7658 36.3823 95.1272 39.2854 112.545L38.7172 112.64Z",
    fill: "#DDAD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4617 85.0965L37.8701 88.6222L38.1418 89.1302L44.7334 85.6044L44.4617 85.0965Z",
    fill: "#DDAD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1849 86.8625L30.9131 87.3704L37.5039 90.8981L37.7757 90.3902L31.1849 86.8625Z",
    fill: "#DDAD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5297 94.4471C28.4037 94.4471 34.7869 81.4228 34.7869 65.3566C34.7869 49.2904 28.4037 36.2661 20.5297 36.2661C12.6556 36.2661 6.27246 49.2904 6.27246 65.3566C6.27246 81.4228 12.6556 94.4471 20.5297 94.4471Z",
    fill: "#DDAD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1176 112.928C16.4151 78.7131 22.0601 44.6229 22.1177 44.2826L22.6856 44.3788C22.6281 44.7183 16.9997 78.7167 22.6858 112.833L22.1176 112.928Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2121 59.3439L20.3193 66.24L20.591 66.748L33.4838 59.8519L33.2121 59.3439Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98474 62.7984L6.71289 63.3063L19.6037 70.2059L19.8755 69.698L6.98474 62.7984Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.297 87.6558C65.072 87.6558 73.8069 69.8331 73.8069 47.8477C73.8069 25.8623 65.072 8.03967 54.297 8.03967C43.522 8.03967 34.7871 25.8623 34.7871 47.8477C34.7871 69.8331 43.522 87.6558 54.297 87.6558Z",
    fill: "#DDAD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5753 112.928C48.7747 66.125 56.4965 19.493 56.5754 19.0275L57.1433 19.1237C57.0646 19.5883 49.3593 66.1286 57.1435 112.833L56.5753 112.928Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7012 39.7133L54.0586 49.15L54.3303 49.658L71.9729 40.2213L71.7012 39.7133Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7113 44.4406L35.4395 44.9485L53.0796 54.3898L53.3514 53.8819L35.7113 44.4406Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.194 103.168C222.22 103.168 225.483 96.5089 225.483 88.2946C225.483 80.0803 222.22 73.4213 218.194 73.4213C214.168 73.4213 210.904 80.0803 210.904 88.2946C210.904 96.5089 214.168 103.168 218.194 103.168Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.52 112.64C220.44 95.1235 217.55 77.6704 217.52 77.4963L216.952 77.5925C216.982 77.7658 219.855 95.1272 216.952 112.545L217.52 112.64Z",
    fill: "#DDAD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.776 85.0964L211.504 85.6044L218.096 89.1301L218.367 88.6221L211.776 85.0964Z",
    fill: "#DDAD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.053 86.8625L218.462 90.3903L218.734 90.8982L225.325 87.3704L225.053 86.8625Z",
    fill: "#DDAD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.708 94.4471C243.582 94.4471 249.966 81.4228 249.966 65.3566C249.966 49.2904 243.582 36.2661 235.708 36.2661C227.834 36.2661 221.451 49.2904 221.451 65.3566C221.451 81.4228 227.834 94.4471 235.708 94.4471Z",
    fill: "#DDAD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.12 112.928C239.822 78.7131 234.177 44.6229 234.12 44.2826L233.552 44.3788C233.609 44.7183 239.238 78.7167 233.552 112.833L234.12 112.928Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.026 59.3438L222.754 59.8518L235.647 66.7479L235.918 66.2399L223.026 59.3438Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.253 62.7984L236.362 69.698L236.634 70.2059L249.525 63.3063L249.253 62.7984Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.941 87.6558C212.716 87.6558 221.45 69.8331 221.45 47.8477C221.45 25.8623 212.716 8.03967 201.941 8.03967C191.166 8.03967 182.431 25.8623 182.431 47.8477C182.431 69.8331 191.166 87.6558 201.941 87.6558Z",
    fill: "#DDAD49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.663 112.928C207.463 66.125 199.742 19.493 199.663 19.0275L199.095 19.1237C199.174 19.5883 206.879 66.1286 199.095 112.833L199.663 112.928Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.536 39.7133L184.265 40.2213L201.907 49.6581L202.179 49.1501L184.536 39.7133Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.527 44.4406L202.887 53.882L203.159 54.3899L220.799 44.9485L220.527 44.4406Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.697 25.4173L150.003 23.5729C148.211 23.3753 147.475 24.3523 147.174 25.1256C145.775 24.5445 144.251 25.3061 144.251 25.3061L148.865 26.9811C148.632 26.3594 148.227 25.817 147.697 25.4173Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3336 9.13474L93.6396 7.29036C91.8482 7.09271 91.1121 8.06973 90.8108 8.84305C89.4113 8.26189 87.8877 9.02353 87.8877 9.02353L92.5016 10.6986C92.2689 10.0768 91.8637 9.53437 91.3336 9.13474Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.267 1.87022L185.573 0.0258296C183.782 -0.171816 183.046 0.805204 182.744 1.57853C181.345 0.997364 179.821 1.759 179.821 1.759L184.435 3.43403C184.202 2.81231 183.797 2.26984 183.267 1.87022Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.923 109.482C187.31 109.482 186.708 109.643 186.177 109.95C185.638 109.463 184.97 109.143 184.252 109.028C183.535 108.913 182.799 109.009 182.135 109.305C181.471 109.6 180.907 110.082 180.512 110.691C180.116 111.301 179.906 112.012 179.907 112.738H191.418C191.355 111.854 190.96 111.027 190.311 110.423C189.663 109.818 188.81 109.482 187.923 109.482Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9398 109.482C70.3268 109.482 69.7246 109.643 69.194 109.95C68.655 109.463 67.9862 109.143 67.2687 109.028C66.5512 108.913 65.8158 109.009 65.1519 109.305C64.488 109.6 63.924 110.082 63.5285 110.691C63.133 111.301 62.9229 112.012 62.9238 112.738H74.4342C74.3715 111.854 73.9761 111.027 73.3277 110.423C72.6793 109.818 71.8261 109.482 70.9398 109.482Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.809 109.482C130.196 109.482 129.594 109.643 129.063 109.95C128.524 109.463 127.855 109.143 127.138 109.028C126.42 108.913 125.685 109.009 125.021 109.305C124.357 109.6 123.793 110.082 123.398 110.691C123.002 111.301 122.792 112.012 122.793 112.738H134.303C134.241 111.854 133.845 111.027 133.197 110.423C132.549 109.818 131.695 109.482 130.809 109.482Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.176 101.26H84.9678V102.331H90.1469V112.508H91.218V102.331H111.39V112.508H112.462V102.331H118.176V101.26Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.242 98.0546H85.0332V99.1258H118.242V98.0546Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.242 95.3765H85.0332V96.4477H118.242V95.3765Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.242 92.6984H85.0332V93.7696H118.242V92.6984Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.03 101.26H136.821V102.331H142V112.508H143.072V102.331H163.244V112.508H164.315V102.331H170.03V101.26Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 98.0546H136.887V99.1258H170.095V98.0546Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 95.3765H136.887V96.4477H170.095V95.3765Z",
    fill: "#003349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 92.6984H136.887V93.7696H170.095V92.6984Z",
    fill: "#003349"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2036_2106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 112.976,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationListEmptyState);
export default __webpack_public_path__ + "static/media/Reservation_List_Empty_State.8d2371799de7b8dff917443962b0d716.svg";
export { ForwardRef as ReactComponent };